import type { ChecklistAttachment, ChecklistItem } from '../types/schema'

export const hasChecklistProof = (item: Pick<ChecklistItem, 'proofFileUrl' | 'proofSubmissionId'>): boolean =>
  Boolean(item.proofFileUrl || item.proofSubmissionId)

export const buildChecklistProofAttachmentUpdates = (attachment: ChecklistAttachment) => ({
  proofSubmissionId: attachment.proofSubmissionId ?? attachment.id,
  proofFileUrl: attachment.downloadUrl,
  proofFileName: attachment.name,
  proofFileStoragePath: attachment.storagePath,
  proofUploadedById: attachment.uploadedById,
  proofUploadedByName: attachment.uploadedByName,
  proofUploadedAt: attachment.uploadedAt,
})

export const buildChecklistProofRemovalUpdates = () => ({
  proofSubmissionId: null,
  proofFileUrl: null,
  proofFileName: null,
  proofFileStoragePath: null,
  proofUploadedById: null,
  proofUploadedByName: null,
  proofUploadedAt: null,
  proofReviewStatus: null,
  proofReviewedAt: null,
  proofReviewedById: null,
  proofReviewedByName: null,
  proofRejectionNote: null,
  isPendingReview: false,
})

export const proofRemovalWorkflowReversion = (
  item: Pick<ChecklistItem, 'requiresProofFile' | 'workflowStatus' | 'previousWorkflowStatus'>,
) => {
  if (item.requiresProofFile !== true) return null
  if (item.workflowStatus !== 'COMPLETED' && item.workflowStatus !== 'ASSESSING') return null
  return item.previousWorkflowStatus
    && item.previousWorkflowStatus !== 'COMPLETED'
    && item.previousWorkflowStatus !== 'ASSESSING'
    ? item.previousWorkflowStatus
    : 'ONGOING'
}
